import { Outlet, useOutletContext } from "react-router-dom";
import { useMemo } from "react";
import { useAppParams, useCustomTranslation } from "@app/hooks";
import { useHandleActivityState } from "@pages/activityBuilder/hooks/useHandleActivityState";
import Sidebar from "@components/sidebar/Sidebar";
import BuilderTopbar from "@components/topbar/BuilderTopbar";

type ContextType = { id: number | null };

const EditActivityContainer = () => {
	const { activityId } = useAppParams();
	const { activity, isFetching } = useHandleActivityState();
	const id = useMemo(() => (activityId ? +activityId : null), [activityId]);
	const translatedLoading = useCustomTranslation('main.loading');
	const translatedAct = useCustomTranslation("main.activity");

	return (
		<div className="edit-activity-container">
			<Sidebar />
			<BuilderTopbar
				activityLabel={isFetching ? `${translatedLoading}...` : `${translatedAct} ${activity?.id}.`}
				projectLabel={activity?.name}
				stepsList={[]}
			/>
			<Outlet context={{ id } satisfies ContextType} />
		</div >
	);
};

export function useId() {
	return useOutletContext<ContextType>();
}

export default EditActivityContainer;
